export const outboundMessageTransformer = (data) => {
    const { threadId, messageText, attachment } = data;
    const attachmentObj = [
        {
            Type: 'Image',
            Path: attachment,
        },
    ];
    return JSON.stringify({
        ThreadID: threadId,
        MessageText: messageText,
        Attachment: attachment ? attachmentObj : null,
    });
};

export const inboundMessageThreadUserTransformer = (data) => {
    const transformedPayload = {};
    try {
        const payload = JSON.parse(JSON.stringify(data));
        const threadUsers = Object.keys(payload.Thread.UserStatus);
        const threadUserData = payload.Thread.UserStatus;
        threadUsers.forEach((user) => {
            transformedPayload[user] = {
                lastReadId: threadUserData[user].LastReadID,
                deletedMessages: threadUserData[user].HiddenMessages || [],
                online: threadUserData[user].Online,
            };
        });
        return transformedPayload;
    } catch (error) {
        return {
            error: error.toString(),
        };
    }
};
